// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".barreHaut .custom-radio label {\n  white-space: nowrap;\n}\n.tableEffectifs > thead > tr > th {\n  position: sticky;\n  inset-block-start: 30px;\n  background: white;\n}\n", ""]);
// Exports
module.exports = exports;
